var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isCurrency)?_c('span',{class:_vm.className},[_vm._v(_vm._s(_vm._f("formatNumber")(_vm.currentNumber,'currency'))+" "),_vm._t("default")],2):_c('span',{class:_vm.className},[_vm._v(_vm._s(_vm._f("formatAmount")(_vm.currentNumber))+" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-167bab8b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-count-up/index.vue
// module id = 4e5A
// module chunks = 23